import { CSSProperties, css as styler } from "@compiled/react";

const skeletonBaseStyles = styler({
    "padding": "4px 8px 6px 8px",
    "width": "50%",
    "margin-top": "6px",
    "background-color": "#EBECF0",
    "borderRadius": "3px"
});

export const Skeleton = ({
    width,
    height,
    styles
}: {
    width: number | string;
    height: number | string;
    styles?: CSSProperties;
}) => {
    return (
        <div
            style={{ ...(styles || {}), width, height }}
            css={[skeletonBaseStyles]}
        />
    );
};
